module.exports = __webpack_public_path__ + "static/media/emoji2.99590e6d.svg";